import { useChartDisplay } from '../../../../ui-components/data-viz-ui/charts/common/common-chart-utils/use-chart-display-reducer';
import { ComponentStateManager } from '../../../common/types';
import { OverTimeUnsegmentedVizExternalProps } from '../../types';
import {
  OverTimeUnsegmentedTableViewActions,
  OverTimeUnsegmentedTableViewState,
} from './types';

export const useOverTimeUnsegmentedTableViewStateManager = (
  // We might need more props later, but I am not sure
  externalProps: OverTimeUnsegmentedVizExternalProps,
  persistenceKey: string
): ComponentStateManager<
  OverTimeUnsegmentedTableViewState,
  OverTimeUnsegmentedTableViewActions
> => {
  const { displayState, displayActions } = useChartDisplay(
    {
      enablePercentage: false,
      enableStack: false,
      enableLabels: false,
      enableLegend: false,
      enableSortOrder: false,
      enableTableView: false,
      globalDisplayState: externalProps.displayGlobalState,
    },
    persistenceKey
  );

  return {
    state: {
      displayState,
    },
    actions: {
      displayActions,
    },
  };
};
